import script from "./StepMedicalVisit.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepMedicalVisit.vue?vue&type=script&setup=true&lang=ts"

import "./StepMedicalVisit.vue?vue&type=style&index=0&id=31bbf4c7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31bbf4c7"]])

export default __exports__